import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';

import { t } from '../../common/i18n';
import { TSFixMe } from '../../frontend-libs/evlapp-types';
import routes from '../../common/constants/routes';
import { CONTACT_URL } from '../../common/constants/common';
import { ButtonLink, Col, Content, Row, Text, TipMessage } from '../../common/components';
import { IAdminRegistration } from './interfaces';
import { IncompleteData } from './IncompleteData';
import { useEffect, useState } from 'react';
import { getAddressLegalEntities, getAddressRegisteredStatus } from '../services/RegistrationService';

// import { IAdminRegistration } from '../Registration.d';

// import { IncompleteData } from './IncompleteData';

export const BuildingConfirm: React.FC<{ state: IAdminRegistration }> = (props) => {
  const namespace = 'AdminRegistration.BuildingConfirm';

  const { state } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [isRegistered, setIsRegistered] = useState(false);
  const [isDeactivated, setIsDeactivated] = useState(false);
  const [housingCooperativeName, setHousingCooperativeName] = useState<string | null>(null);

  useEffect(() => {
    async function fetch() {
      const res = await getAddressRegisteredStatus(state?.building?.addressId || '');
      // isRegistered stays the source of truth for registered-vs-available (backwards compatible);
      // status only further distinguishes a deactivated building.
      setIsRegistered(res.isRegistered);
      setIsDeactivated(res.status === 'deactivated');
      setIsLoading(false);
    }
    fetch();
  }, [state.building.addressId]);

  useEffect(() => {
    // Nezávisle na hlavním fetchi (ARES lookup může trvat) — upozornění na bytové
    // družstvo se doplní, až dorazí. Chyba = žádné upozornění, registrace běží dál.
    getAddressLegalEntities(state?.building?.addressId || '')
      .then((res) => {
        if (!res.legalEntity && res.housingCooperativeName) setHousingCooperativeName(res.housingCooperativeName);
      })
      .catch(() => undefined);
  }, [state.building.addressId]);

  const address = state?.building?.address;
  const isValidType = state?.building?.type === 'other' ? false : true;

  // Address is free and the building type is registrable → user can continue to the next step.
  const canContinue = isValidType && !isRegistered;
  // Deactivated building and non-registrable type both point the user to app support.
  const showSupportButton = isDeactivated || !isValidType;

  // Return page with incomplete date
  if (!address) return <IncompleteData />;

  const headingKey = !isValidType
    ? 'headingNotValidType'
    : isDeactivated
      ? 'headingDeactivated'
      : isRegistered
        ? 'headingRegistered'
        : 'heading';

  const subheadingKey = !isValidType
    ? 'subheadingNotValidType'
    : isDeactivated
      ? 'subheadingDeactivated'
      : isRegistered
        ? 'subheadingRegistered'
        : 'subheading';

  return (
    <Content isLoading={isLoading}>
      <div className="OnboardingForm">
        <Row>
          <Col className="mb-4">
            <Text size="h1" className="mb-4">
              <Trans i18nKey={`${namespace}.${headingKey}`}>
                <span className="text SystemOrange">{{ address } as TSFixMe}</span>
              </Trans>
            </Text>
            <Text size="body-large" weight="500" color="Neutral700">
              {t(subheadingKey, namespace)}
            </Text>
            {canContinue && housingCooperativeName && (
              <TipMessage variant="warning" title={t('housingCooperativeWarningTitle', namespace)} className="mt-2">
                {t('housingCooperativeWarningText', namespace, { name: housingCooperativeName })}
              </TipMessage>
            )}
          </Col>
        </Row>

        <Row>
          <Col className="mb-2">
            {showSupportButton ? (
              <ButtonLink external={true} to={CONTACT_URL} target="_blank" title={t('contactSupport', namespace)} />
            ) : (
              <ButtonLink
                title={t(`${canContinue ? 'nextStep' : 'prevStep'}`, namespace)}
                to={{ pathname: `${routes.registration}${canContinue ? 'legal-entity/' : ''}` }}
                state={state}
              />
            )}
          </Col>
        </Row>

        {(canContinue || showSupportButton) && (
          <Row>
            <Col>
              <div className="ml-auto mr-auto">
                <Link className="text-body-large Primary500 Weight500" to={{ pathname: routes.registration }}>
                  {t('prevStep', namespace)}
                </Link>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </Content>
  );
};
